import { render, staticRenderFns } from "./EnquiryFollowUps.vue?vue&type=template&id=e19d25f4&scoped=true&"
import script from "./EnquiryFollowUps.vue?vue&type=script&lang=js&"
export * from "./EnquiryFollowUps.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryFollowUps.vue?vue&type=style&index=0&id=e19d25f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19d25f4",
  null
  
)

export default component.exports